import React from 'react';
import { APP_STORE_URL, PLAY_STORE_URL } from '../../constants/links';

/** 56px in the hero, 58px in the download CTA. */
const cls = (tall?: boolean) =>
    `inline-flex items-center gap-[11px] rounded-xl border border-white/25 bg-black text-white transition-[transform,border-color] duration-150 ease-out hover:border-white/50 active:scale-[0.97] ${
        tall ? 'h-[58px] px-[22px]' : 'h-14 px-5'
    }`;

type LabelProps = { kicker: string; name: string };

const Label: React.FC<LabelProps> = ({ kicker, name }) => (
    <span className="grid gap-px text-left">
        <span className="text-[10px] leading-none text-white/80">{kicker}</span>
        <span className="text-[19px] font-semibold leading-[1.15] tracking-[-0.01em]">{name}</span>
    </span>
);

export const AppStoreButton: React.FC<{ tall?: boolean }> = ({ tall }) => (
    <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer" className={cls(tall)}>
        <svg width="25" height="25" viewBox="0 0 24 24" fill="#fff" aria-hidden="true">
            <path d="M18.71,19.5C17.88,20.74 17,21.95 15.66,21.97C14.32,22 13.89,21.18 12.37,21.18C10.84,21.18 10.37,21.95 9.1,22C7.79,22.05 6.8,20.68 5.96,19.47C4.25,17 2.94,12.45 4.7,9.39C5.57,7.87 7.13,6.91 8.82,6.88C10.1,6.86 11.32,7.75 12.11,7.75C12.89,7.75 14.37,6.68 15.92,6.84C16.57,6.87 18.39,7.1 19.56,8.82C19.47,8.88 17.39,10.1 17.41,12.63C17.44,15.65 20.06,16.66 20.09,16.67C20.06,16.74 19.67,18.11 18.71,19.5M13,3.5C13.73,2.67 14.94,2.04 15.94,2C16.07,3.17 15.6,4.35 14.9,5.19C14.21,6.04 13.07,6.7 11.95,6.61C11.8,5.46 12.36,4.26 13,3.5Z" />
        </svg>
        <Label kicker="Download on the" name="App Store" />
    </a>
);

export const GooglePlayButton: React.FC<{ tall?: boolean }> = ({ tall }) => (
    <a href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer" className={cls(tall)}>
        <svg width="23" height="25" viewBox="0 0 24 24" aria-hidden="true">
            <path
                d="M3.6 1.84C3.24 2.09 3 2.5 3 3.05v17.9c0 .55.24.96.6 1.21l9.53-10.16L3.6 1.84z"
                fill="#00D0FF"
            />
            <path
                d="M17.1 8.28L5.42 1.66C5 1.42 4.6 1.4 4.28 1.6l9.53 10.16 3.29-3.48z"
                fill="#00E47B"
            />
            <path
                d="M20.9 10.44l-3.8-2.16-3.29 3.48 3.29 3.48 3.8-2.15c.9-.51.9-2.14 0-2.65z"
                fill="#FFCE00"
            />
            <path
                d="M4.28 22.4c.32.2.72.18 1.14-.06l11.68-6.62-3.29-3.48L4.28 22.4z"
                fill="#FF3A44"
            />
        </svg>
        <Label kicker="Get it on" name="Google Play" />
    </a>
);
